export default {
  contact: 'card-panel white col s12 contact-card',
}



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/resources/styles/cards.js